import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import HomeSlider from './components/HomeSlider';
// import Login2 from './components/Login2'; fffd
import RegisterPopup from './components/RegisterPopup'; // Make sure this path is correct
import Features from './Features';

function App() {
  const [openRegister, setOpenRegister] = useState(false);

  return (
    <BrowserRouter>
      <div>
        <Navbar onGetStartedClick={() => setOpenRegister(true)} />
        {/* <Login2 /> */}
         <HomeSlider
  setOpenLogin={() => setOpenRegister(true)}
  setToggleForm={() => {}}
/>
<Features/>
        <RegisterPopup open={openRegister} handleClose={() => setOpenRegister(false)} />
       

      </div>
    </BrowserRouter>
  );
}

export default App;
